import DefaultLayout from '../../layouts/DefaultLayout/DefaultLayout'
import ZoneAdvertsContent from '../../components/ZoneAdverts/ZoneAdverts'

const ZoneAdverts = () => {
  return (
    <DefaultLayout>
      <ZoneAdvertsContent />
    </DefaultLayout>
  )
}

export default ZoneAdverts
